import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { center } from '@turf/turf';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import { $investProRegions } from '../../../models/investPro/index.js';
import { flyTo } from '../../../utils/mapbox-utils.js';

const onClick = (e) => {
  const currentZoom = window.map.getZoom();
  if (currentZoom < 5) {
    const centerCoords = center(e.features[0]);
    flyTo(centerCoords.geometry.coordinates, 5);
  }
};

function InvestProRegions() {
  const mapLoaded = useUnit($mapLoaded);
  const polygons = useUnit($investProRegions);

  const createLayer = (update) => {
    const investProAdminData = {
      type: 'FeatureCollection',
      features: polygons,
    };

    if (update) {
      window.map
        .getSource('invest_pro_regions_source')
        .setData(investProAdminData);
    } else {
      if (!window.map.getSource('invest_pro_regions_source')) {
        window.map.addSource('invest_pro_regions_source', {
          type: 'geojson',
          data: investProAdminData,
        });
      }

      if (!window.map.getLayer('invest_pro_regions_layer')) {
        window.map.addLayer({
          id: 'invest_pro_regions_layer',
          type: 'fill',
          source: 'invest_pro_regions_source',
          paint: {
            'fill-color': 'green',
            'fill-opacity': [
              'interpolate',
              ['linear'],
              ['zoom'],
              4.3,
              0.8,
              5,
              0,
            ],
            'fill-outline-color': '#000000',
          },
        });

        window.map.on('click', 'invest_pro_regions_layer', onClick);
      }
    }
  };

  useEffect(() => {
    if (mapLoaded && polygons) {
      if (window.map.getLayer('invest_pro_regions_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, polygons]);

  return null;
}

export default InvestProRegions;
